export default "__VITE_ASSET__Dlt6dNuA__"